/**
 * Utility functions for extracting RSS URLs from JSON content
 */

/**
 * Extracts all RSS URLs from JSON object that follows the pattern [RSS=url]
 * @param {object} jsonObject - The JSON object to search in
 * @returns {Array<string>} - Array of extracted RSS URLs
 */
export function extractRssUrl(jsonObject) {
  if (!jsonObject || typeof jsonObject !== 'object') {
    return [];
  }

  const rssUrls = [];

  // Recursively search through the object for RSS URLs
  function searchForRssUrl(obj) {
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'string') {
        // Pattern to match [RSS(uuid)=url] where url can be any valid URL
        const rssPattern = /\[RSS\(([^)]+)\)=([^\]]+)\]/gi;
        let match;
        
        // Find all matches in the string
        while ((match = rssPattern.exec(value)) !== null) {
          if (match[2]) {
            rssUrls.push(match[2].trim());
          }
        }
      } else if (typeof value === 'object' && value !== null) {
        searchForRssUrl(value);
      }
    }
  }

  searchForRssUrl(jsonObject);
  return rssUrls;
}